import PropTypes from 'prop-types';
import { NavLink as RouterLink } from 'react-router-dom';
// @mui
import { Box, List, ListItemText, Stack, alpha, useTheme } from '@mui/material';
//
import { StyledNavItem, StyledNavItemIcon } from './styles';

// ----------------------------------------------------------------------

NavSection.propTypes = {
  data: PropTypes.array,
};

export default function NavSection({ data = [], ...other }) {
  return (
    <Box {...other}>
      <List disablePadding sx={{ p: 1 }}>
        <Stack spacing={1}>
          {data.map((item) => (
            <NavItem key={item.title} item={item} />
          ))}
        </Stack>
      </List>
    </Box>
  );
}

// ----------------------------------------------------------------------

NavItem.propTypes = {
  item: PropTypes.object,
};

function NavItem({ item }) {
  const { title, path, icon } = item;

  const theme = useTheme();

  return (
    <StyledNavItem
      component={RouterLink}
      to={path}
      sx={{
        px: 1,
        '&.active': {
          color: 'primary.main',
          fontWeight: 'fontWeightMedium',
          bgcolor: alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity),
        },
      }}
    >
      <Stack direction={'row'} alignItems={'center'} justifyContent={'center'} spacing={2}>
        {icon && <StyledNavItemIcon>{icon}</StyledNavItemIcon>}

        <ListItemText disableTypography primary={title} />
      </Stack>
    </StyledNavItem>
  );
}
